import { nombrePoblacionPorId } from "./poblacionesFavoritas";
import { normalizeProvinciaId } from "./normalizeLocalizacionIds";

const PROVINCIAS_COMUNES = [
  { id: "03", nombre: "Alicante" },
  { id: "46", nombre: "Valencia" },
  { id: "12", nombre: "Castellón" },
  { id: "28", nombre: "Madrid" },
  { id: "08", nombre: "Barcelona" },
];

/** Población/provincia de la ficha para restringir sugerencias Google Places en modales. */
export function placesLocalityHintFromForm(form) {
  if (!form || typeof form !== "object") return null;
  const pob = String(
    form.poblacion_nombre || form.poblacion || nombrePoblacionPorId(form.poblacion_id) || "",
  ).trim();
  if (!pob) return null;
  const provId = normalizeProvinciaId(form.provincia_id);
  const prov =
    String(form.provincia_nombre || form.provincia || "").trim()
    || PROVINCIAS_COMUNES.find((p) => p.id === provId)?.nombre
    || "";
  return { poblacion: pob, provincia: prov };
}
